export default "__VITE_ASSET__xNG2QSj1__"